import axios from '../../axios'
export default {
  /**
   * 课程专题
   */
  queryCourseToptic: (studyMotId: string, curPage: number) => {
    return axios.get('/learn/app/clientapi/course/tobStudyMotCourseList.do', {
      params: {
        studyMotId,
        isZip: 1,
        numPerPage: 30,
        curPage,
      },
    })
  },
}
